import React from "react";
import { Button } from "react-bootstrap";
import BackIcon from "../../assets/icons/svg/arrow_back.svg?react";
import { useNavigate } from "react-router-dom";

type PageHeaderProps = {
  title: string | React.ReactNode;
  buttonText?: string;
  onButtonClick?: () => void;
  backPath?: string;
  children?: JSX.Element;
  icon?: React.ReactNode;
};
const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  children,
  buttonText = "",
  onButtonClick,
  backPath = "",
  icon,
}) => {
  const navigate = useNavigate();
  return (
    <div className="subHeader pageHeader z-3 px-3">
      <div className="d-flex align-items-center gap-2">
        {backPath && (
          <BackIcon
            className="bi iconSvg"
            onClick={() => navigate(backPath)}
            role="button"
          />
        )}
        {icon}
        <h5>{title}</h5>
      </div>
      {buttonText && (
        <div className="d-flex align-items-center">
          <Button variant="outline-primary" onClick={onButtonClick}>
            {buttonText}
          </Button>
        </div>
      )}
      {children}
    </div>
  );
};

export default PageHeader;
